<script setup lang="ts">
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useMutation } from '@tanstack/vue-query'

interface Props {
  active: boolean
  carId: number
}

const props = defineProps<Props>()
const emits = defineEmits(['close'])

const { $trpc } = useNuxtApp()
const push = usePush()
const { t } = useI18n()
async function mutationFn() {
  return await $trpc.auctions.releaseItem.mutate({
    carId: props.carId,
  })
}

const { mutate: freeReservation, isLoading } = useMutation({
  mutationFn,
  onError: (error: unknown) => {
    const { message, handled } = getError(error)

    if (!handled) {
      push.error(message)
    }
  },
  onSuccess: (resp) => {
    emits('close')

    push[resp.data.success ? 'success' : 'error'](
      resp.data.message ?? t('unexpected-error'),
    )
  },
})
</script>

<template>
  <CommonDialog :opened="active" @close="$emit('close')">
    <template #title>
      {{ $t('shared-car.free-reservation-modal.title') }}
    </template>
    <template #content>
      <div class="flex w-full flex-col gap-2">
        <p class="text-sm text-gray-500">
          {{ $t('shared-car.free-reservation-modal.description') }}
        </p>
      </div>
    </template>
    <template #buttons>
      <footer class="flex w-full justify-end gap-2">
        <ElementsButton class="flex-1 bg-red" @click="$emit('close')">
          {{ $t('bid-confirmation-modal.cancel') }}
        </ElementsButton>

        <ElementsButton
          class="ml-auto flex-1"
          :disabled="isLoading"
          @click="freeReservation"
        >
          {{ isLoading ? $t('loading') : $t('bid-confirmation-modal.confirm') }}
        </ElementsButton>
      </footer>
    </template>
  </CommonDialog>
</template>
